import { render, staticRenderFns } from "./Table_v1.vue?vue&type=template&id=57ea2e7a&scoped=true&lang=pug"
import script from "./Table_v1.vue?vue&type=script&lang=js"
export * from "./Table_v1.vue?vue&type=script&lang=js"
import style0 from "./Table_v1.vue?vue&type=style&index=0&id=57ea2e7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ea2e7a",
  null
  
)

export default component.exports